import { RestSelectOption } from '@/forms/types';

export const restOptionToFormOption = <T extends RestSelectOption>(
  option: T,
  getValue: (option: T) => string = (o) => o.name,
): Omit<T, 'id'> & { id: string; value: string } => ({
  ...option,
  id: option.id.toString(),
  value: getValue(option),
});
